module.exports = __webpack_public_path__ + "static/media/tty.4aa75f50.svg";